export default __webpack_public_path__ + "static/media/gongan-logo.71ed15b3.png";